import { P, Strong } from '@ahmdigital/ui';

import limitsRollover from './limits-rollover';

export default {
  description: (
    <P>
      You also get the biggest bunch of extras we’ve got. Plus heaps of <Strong>routine dental</Strong> to keep you and
      your teeth happy.
    </P>
  ),
  getSellingPoints: () => [
    {
      description: 'Get on a first-name basis with your dentist (if you want to!)',
      title: 'Heaps of routine dental',
    },
    {
      description: 'on included extras.',
      title: 'No 2 or 6 month waiting periods',
    },
    {
      description: 'Available at select dentists.',
      title: 'No gap dental check-ups',
    },
  ],
  limitsRollover: {
    disclaimer: limitsRollover.disclaimer.superExtras,
    rollingOverLimitsText: limitsRollover.rollingOverLimitsText.superExtras,
  },
};
